import _ from 'lodash';

export namespace Nix {
  export const { isNil, isEmpty } = _;

  export const isNotNil = <T>(value?: T): value is Exclude<T, null | undefined> => !isNil(value);
  export const isNotEmpty = <T>(value?: T): boolean => !isEmpty(value);
}
